import * as React from 'react';
import { FaImage, FaVideo } from "react-icons/fa6";
import { Box, List, ListItemButton } from '@mui/material';

export default function ViewList({ list, keyname }) {
  return (
    <List component="nav" sx={{ maxWidth: 320, maxHeight: 200, overflowY: 'auto' }}>
      {list.map((d, i) => <>
        <ListItemButton key={i}>
          <FaImage />
          <Box sx={{ ml: 2 }} >{d[keyname]}</Box>
        </ListItemButton>
      </>)}
    </List>
  );
}
